// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { text } from '../../tokens/themeColors/text';
export var tableColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var tx = text(mode);
    return {
        border: bd.default,
        text: tx.primary,
        // Not wired via MuiTableCell — no dedicated secondary-text slot exists on <td>.
        // Consumers compose it themselves (see Table.stories.tsx hasSecondaryText), and
        // it already resolves to this same value through the theme's palette.text.secondary.
        secondaryText: tx.secondary,
        headText: tx.secondary,
        disabledText: tx.disabled,
        active: {
            background: bg.state.selected2
        },
        disabled: {
            background: bg.state.disabled1
        },
        hover: {
            background: bg.state.hover0
        },
        selected: {
            background: bg.state.selected1
        }
    };
};

//# sourceMappingURL=tableColors.js.map